import { permissionsList, userLoginPermissions } from "@/router/types";
import * as ramda from "ramda";
import { setUserPermissions } from "@payping/redux/actions";
import { store } from "@/index";
import { useAppSelector } from "@/utils/redux";
import { useMemo, useEffect } from "react";

export const useCheckUserPermissions = () => {
  const agreementAccepted = useAppSelector((state) => state.user.checks?.agreementAccepted);
  const isSettlement = useAppSelector((state) => state.user.isSettlement);
  const isDepositActivate = useAppSelector((state) => state.cashOuts.overview?.isDepositActivate);
  const digitalAccountAvailableBanks = useAppSelector((state) => state.digitalAccount.availableBanks);
  const permissions = useAppSelector((state) => state.user.permissions);

  const hasDigitalAccountBanks = digitalAccountAvailableBanks.length > 0;

  const computedPermissions = useMemo(() => {
    let temp: (typeof permissionsList)[keyof typeof permissionsList][] = [...Object.values(userLoginPermissions)];

    if (agreementAccepted) {
      temp = [
        ...temp,
        permissionsList.settingsPersonalList,
        permissionsList.settingsPersonalEdit,
        permissionsList.settingsPersonalEditMobile,
        permissionsList.settingsBusinessList,
        permissionsList.settingsBusinessEdit,
        permissionsList.settingsBusinessEditMobile,
        permissionsList.settingsBankList,
        permissionsList.settingsBankEdit,
        permissionsList.settingsBankEditMobile,
      ];
    }

    if (isSettlement && isDepositActivate) {
      temp = [...temp, permissionsList.settlementID, permissionsList.settlementIDCreate];
    }

    if (isSettlement) {
      temp = [
        ...temp,
        permissionsList.settlementCreate,
        permissionsList.settlementOverview,
        permissionsList.settlementTransactionList,
        permissionsList.settlementList,
        permissionsList.settlementRecordList,
      ];
    }

    if (hasDigitalAccountBanks) {
      temp = [...temp, permissionsList.digitalAccountRoot];
    }

    return temp;
  }, [agreementAccepted, isSettlement, isDepositActivate, hasDigitalAccountBanks]);

  useEffect(() => {
    if (!ramda.equals(permissions, computedPermissions)) {
      store.dispatch(setUserPermissions(computedPermissions));
    }
  }, [permissions, computedPermissions]);
};
